export const delegatePackageConstants = {
  // EDIT_DELEGATE_PACKAGE: 建立寄放物品包裹
  EDIT_DELEGATE_PACKAGE_REQUEST: "DELEGATE_PACKAGE_EDIT_DELEGATE_PACKAGE_REQUEST",
  EDIT_DELEGATE_PACKAGE_DONE: "DELEGATE_PACKAGE_EDIT_DELEGATE_PACKAGE_DONE",
  // GET_ALL: 取得所有寄物包裹
  GET_ALL_REQUEST: "DELEGATE_PACKAGE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "DELEGATE_PACKAGE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "DELEGATE_PACKAGE_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "DELEGATE_PACKAGE_RESET_ALL_SUCCESS",
  // GET_TYPE_OPTIONS: 取得寄放物品類型選項
  GET_TYPE_OPTIONS_REQUEST: "DELEGATE_PACKAGE_GET_TYPE_OPTIONS_REQUEST",
  GET_TYPE_OPTIONS_SUCCESS: "DELEGATE_PACKAGE_GET_TYPE_OPTIONS_SUCCESS",
  GET_TYPE_OPTIONS_FAILURE: "DELEGATE_PACKAGE_GET_TYPE_OPTIONS_FAILURE",
  RESET_TYPE_OPTIONS_SUCCESS: "DELEGATE_PACKAGE_RESET_TYPE_OPTIONS_SUCCESS"
};
